<button [disabled]="disabled" class="tertiary-btn-action">
  <mat-icon>{{icon}}</mat-icon>
  <label class="editable-label">{{label}}</label>
</button>
